import React, {Component} from 'react';
import { Link, withRouter } from 'react-router-dom';

import { PageSettings } from '../../config/page-settings.js';
import BG from '../../assets/images/city-bg.jpg';
import LogoSBMS from '../../assets/images/logoSBMS.png';
import LogoArtajasa from '../../assets/images/artajasa.png';

import withNotification from '../../components/HOCNotification/HOCNotification.component';
// import Auth from '../../services/auth';
import { COPYRIGHT, RESPONSE } from '../../config/constants';
import Services from '../../services/service';

// const auth = new Auth();
const { SUCCESS, FAILED } = RESPONSE;

class FormStaff extends Component {
	static contextType = PageSettings;

	constructor(props) {
    super(props);
    this.state = {
      isLogin: true,
      firstName: '',
      lastName: '',
      email: '',
      oldPassword: '',
      newPassword: '',
      nip:'',
      registrationCode: '',
      validatePassword: true,
      message: ''
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

	componentDidMount() {
		this.context.handleSetPageSidebar(false);
		this.context.handleSetPageHeader(false);
		this.context.handleSetBodyWhiteBg(true);
	}

	componentWillUnmount() {
		this.context.handleSetPageSidebar(true);
		this.context.handleSetPageHeader(true);
		this.context.handleSetBodyWhiteBg(false);
	}

  handleFieldChange = (key) => (e) => {
    const state = { [key]: e.target.value };
    this.setState(state);
  }

	handleSubmit(event) {
		event.preventDefault();
    this.setState({ isForgotPassword: false });
  }

  handleSubmitEmail = (e) => {
    e.preventDefault();
    const payload = {
      username: this.state.email
    };

    Services.postForgotPassword(payload)
      .then(res => {
        this.props.addNotification('success', 'Success', 'Please check your email for new registration code', 'top-right');
        this.setState({isForgotPassword: false})
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
      });
  }

  handleSubmitVerify = (e) => {
    e.preventDefault();
    const { oldPassword, newPassword, email, registrationCode } = this.state;

    if(oldPassword !== newPassword) {
      this.setState({ validatePassword: false, message: 'is-invalid' });
      return;
    } else {
      this.setState({ validatePassword: true, message: 'is-valid' });
    }

    const payload = {
      username: email,
      securityCode: registrationCode,
      newPassword: newPassword
    };

    Services.postVerifyPassword(payload)
      .then(res => {
        this.props.addNotification('success', 'Success', 'Please login with your new password', 'top-right');
        this.setState({isForgotPassword: false})
        setTimeout(window.location.replace('/user/login'));
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
      });
  };

  handleRegister = (e) => {
	  e.preventDefault();
    const { newPassword, firstName, lastName, email, nip, division } = this.state;
    const payload = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      nip: nip,
      division: division,
      password: newPassword
    }
    Services.postRegisterEmployee(payload)
      .then(res => {
        this.props.addNotification('success', 'Success', 'Employee registered', 'top-right');
        setTimeout(window.location.replace('/user/form-staff'));
      })
      .catch(err => {
        this.props.addNotification('danger', 'Failed', 'Failed to register employee', 'top-right');
      })
  };

  handleLoginEmployee = (e) => {
    e.preventDefault();
    const { username, password } = this.state;
    const payload = {
      email: username,
      password: password
    }
    Services.postLoginEmployee(payload)
      .then(res => {
        this.toggleNotification(SUCCESS);
        this.props.history.push({
          pathname: '/user/form-visitor',
          state: {
            visitorType: 2,
            userName: res.data.firstName + ' ' + res.data.lastName
          }
        });
      })
      .catch(err => {
        console.log(err);
        this.toggleNotification(FAILED);
      })
  };

  toggleNotification = action => {
    switch(action){
      case SUCCESS:
        this.props.addNotification('success', 'Success', 'Login successful', 'top-right');
        break;
      case FAILED:
        this.props.addNotification('danger', 'Failed', 'Oops something went wrong !', 'top-right');
        break;
      default:
        break;
    }
  };

  renderFormForgotPassword = () => (
    <div className="login-content">
      <form className="margin-bottom-0" onSubmit={this.handleSubmitEmail}>
        <div className="form-group m-b-15">
          <input type="email" value={this.state.email} className="form-control form-control-lg" onChange={this.handleFieldChange('email')} placeholder="Email Address" required />
        </div>
        <div className="login-buttons">
          <button className="btn btn-success btn-block btn-lg">Submit</button>
        </div>
        <hr />
        <p className="text-center text-grey-darker">
          {COPYRIGHT}
        </p>
        <div className="text-center">
          <img src={LogoArtajasa} alt="logo_artajasa" width={"64px"}/>
        </div>
      </form>
    </div>
  );

  renderFormChangePassword = () => {
    const { oldPassword, newPassword, registrationCode, message } = this.state;

    return (
      <div className="login-content">
        <form className="margin-bottom-0" onSubmit={this.handleSubmitVerify}>
          <div className="form-group m-b-15">
            <input type="password" value={oldPassword} className="form-control form-control-lg" onChange={this.handleFieldChange('oldPassword')} placeholder="New Password" required />
          </div>
          <div className="form-group cus m-b-15">
            <input type="password" value={newPassword} className={`form-control form-control-lg ${message}`} onChange={this.handleFieldChange('newPassword')} placeholder="Verify Password" required />
            <div className="invalid-feedback">Please input same password</div>
          </div>
          <div className="form-group m-b-15">
            <input type="text" value={registrationCode} className="form-control form-control-lg" onChange={this.handleFieldChange('registrationCode')} placeholder="OTP" required />
          </div>
          <div className="login-buttons">
            <button className="btn btn-success btn-block btn-lg">Submit</button>
          </div>
          <hr />
          <p className="text-center text-grey-darker">
            {COPYRIGHT}
          </p>
          <div className="text-center">
            <img src={LogoArtajasa} alt="logo_artajasa" width={"64px"}/>
          </div>
        </form>
      </div>
    );
  }

  renderFormLogin = () => {
    return (
      <div className="login-content">
        <form className="margin-bottom-0" onSubmit={this.handleLoginEmployee}>
          <div className="form-group m-b-15">
            <input type="text" className="form-control form-control-lg" onChange={this.handleFieldChange('username')} placeholder="Email Address" required />
          </div>
          <div className="form-group m-b-15">
            <input type="password" className="form-control form-control-lg" onChange={this.handleFieldChange('password')} placeholder="Password" required />
          </div>
          <div className="login-buttons">
            <button type="submit" className="btn btn-success btn-block btn-lg">Sign Me In</button>
          </div>
          <div className="m-t-20 m-b-40 p-b-40 text-inverse text-center">
            Belum punya akun? Klik <Link to="/user/form-staff" onClick={() => this.setState({ isLogin: !this.state.isLogin})}>di sini</Link> untuk registrasi.
          </div>
          <hr />
          <p className="text-center text-grey-darker">
            {COPYRIGHT}
          </p>
          <div className="text-center">
            <img src={LogoArtajasa} alt="logo_artajasa" width={"64px"}/>
          </div>
        </form>
      </div>
    )
  }

  renderFormRegister = () => {
    const { oldPassword, newPassword, message } = this.state;
    if(newPassword !== '') {
      if( oldPassword!==newPassword ) {
        document.getElementById('confirm_password').setCustomValidity('Password not match')
      } else {
        document.getElementById('confirm_password').setCustomValidity('')
      }
    }
    return (
      <div className="login-content">
        <form className="margin-bottom-0" onSubmit={this.handleRegister}>
          <div className="form-group m-b-15">
            <label>Nama</label>
            <div className="d-flex justify-content-between">
            <input onChange={this.handleFieldChange('firstName')} type="text" className="form-control" placeholder="Nama depan" required />
            <input onChange={this.handleFieldChange('lastName')} type="text" className="form-control" placeholder="Nama belakang" required />
            </div>
          </div>
          <div className="form-group cus m-b-15">
            <label>Email</label>
            <input type="email" className={`form-control form-control-lg ${message}`} onChange={this.handleFieldChange('email')} placeholder="email" required />
            <div className="invalid-feedback">Please input valid email</div>
          </div>
          <div className="form-group cus m-b-15">
            <label>Nomor Pegawai</label>
            <input type="text" className={`form-control form-control-lg ${message}`} onChange={this.handleFieldChange('nip')} placeholder="NIP" required />
            <div className="invalid-feedback">Please input valid input</div>
          </div>
          <div className="form-group cus m-b-15">
            <label>Divisi</label>
            <input type="text" className={`form-control form-control-lg ${message}`} onChange={this.handleFieldChange('divisi')} placeholder="Divisi" required />
            <div className="invalid-feedback">Please input valid input</div>
          </div>
          <div className="form-group m-b-15">
            <label>Password</label>
            <input type="password" value={oldPassword} className="form-control form-control-lg" onChange={this.handleFieldChange('oldPassword')} placeholder="New Password" required />
          </div>
          <div className="form-group cus m-b-15">
            <input id="confirm_password" type="password" value={newPassword} className={`form-control form-control-lg ${message}`} onChange={this.handleFieldChange('newPassword')} placeholder="Verify Password" required />
            <div className="invalid-feedback">Please input same password</div>
          </div>
          <div className="login-buttons">
            <button className="btn btn-success btn-block btn-lg">Register</button>
          </div>
          <div className="m-t-20 m-b-40 p-b-40 text-inverse text-center">
            Sudah punya akun? Klik <Link to="/user/form-staff" onClick={() => this.setState({ isLogin: !this.state.isLogin})}>di sini</Link> untuk login.
          </div>
          <hr />
          <p className="text-center text-grey-darker">
            {COPYRIGHT}
          </p>
          <div className="text-center">
            <img src={LogoArtajasa} alt="logo_artajasa" width={"64px"}/>
          </div>
        </form>
      </div>
    );
  }

	render() {
		return (
			<div className="login login-with-news-feed">
				<div className="news-feed">
					<div className="news-image" style={{backgroundImage: `url(${BG})`}}></div>
					<div className="news-caption">
          <h4 className="caption-title">SIMPONI - ARTAJASA</h4>
            <p>Sistem Monitoring Perangkat Operasional Dan Infrastruktur</p>
					</div>
				</div>
				<div className="right-content">
					<div className="login-header">
						<div className="brand">
							<img src={LogoSBMS} alt="logo_sbms"></img>
							<small></small>
						</div>
						<div className="icon">
							<i className="fa fa-sign-in"></i>
						</div>
					</div>
          {this.state.isLogin ? this.renderFormLogin() : this.renderFormRegister()}
				</div>
			</div>
		)
	}
}

export default withNotification(withRouter(FormStaff));
